module.exports = __webpack_public_path__ + "img/2.30ab2d6b.png";